import React from 'react';
import { FileWarning, Loader2 } from 'lucide-react';

/*
 * Bug 6 (2026-10-09, «KPIS orbis 2.0»): el motor no conserva las imágenes DENTRO de la celda de Excel 365 y al
 * guardar las borraba del archivo. Un libro que las trae se abre solo para ver (lo decide el backend en
 * /office/config) y aquí se explica por qué, con una salida: una copia editable; el original no cambia.
 */
export const TEXTO_IMAGENES_EN_CELDA = 'Este archivo tiene imágenes dentro de celdas que el editor no puede conservar. '
  + 'Para editarlo sin perderlas, descárgalo y ábrelo en Excel.';

export default function AvisoImagenesEnCelda({ puedeCopiar, creando, onCopiar }) {
  return (
    <div className="zo-aviso" role="status" data-testid="zo-aviso-imagenes-celda">
      <FileWarning className="h-4 w-4 shrink-0" />
      <span>{TEXTO_IMAGENES_EN_CELDA}</span>
      {puedeCopiar && (
        <button type="button" className="zo-btn-primary" onClick={onCopiar} disabled={creando} data-testid="zo-copia-editable">
          {creando && <Loader2 className="h-4 w-4 animate-spin" />} Crear copia editable
        </button>
      )}
    </div>
  );
}
